.carousel :global(.carousel-indicators) {
    bottom: -10px;
}
.carousel :global(.carousel-indicators button) {
    height: 14px;
    width: 14px;
    background-color: #cad8df;
    border-radius: 50%;
    border: none;
}
.carousel :global(.carousel-indicators button.active) {
    background: linear-gradient(0deg, #bbce2c 0%, #daf134 100%);
}

.carousel :global(.carousel-control-prev) {
    width: auto;
}

.carousel :global(.carousel-control-next ) {
    width: auto;
}

.carousel :global(.carousel-control-next:focus), .carousel :global(.carousel-control-prev:focus) {
    opacity: .5;
}
.carousel :global(.carousel-control-next:hover), .carousel :global(.carousel-control-prev:hover) {
    opacity: .9;
}